// extracted by mini-css-extract-plugin
export var backdropBlur = "_fr-0";
export var contentCard = "_fr-5";
export var frame = "_fr-2";
export var image = "_fr-4";
export var imagePane = "_fr-3";
export var modal = "_fr-1";